import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, MenuProps } from '../../components/MenuItem';
import bank from './static/img/bank.svg';

export const Menu: React.FC<MenuProps> = (props) => {
  const { t } = useTranslation('byBank');

  return (
    <MenuItem
      {...props}
      icon={bank}
      name={t('By bank transfer')}
      description={t('To United Traders accounts')}
    />
  );
};
